import React from 'react';
import MainRouter from "./MainRouter";

var AppRouter = React.createClass({

    render: function() {
        return (<MainRouter location={this.props.location}/>)
    }
});

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js